/* 🤖 this file was generated by svg-to-ts */
export const sbIconsChartLine: {
  name: 'chart-line';
  data: string;
} = {
  name: 'chart-line',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M4.4 11.2A1.2 1.2 0 0 0 5.6 10a.615.615 0 0 0 0-.12l2.232-2.232H8.2l1.288 1.288V9a1.2 1.2 0 0 0 2.4 0v-.064L14.8 6a1.2 1.2 0 1 0-1.2-1.2.617.617 0 0 0 0 .12l-2.888 2.888h-.128L9.2 6.4a1.2 1.2 0 0 0-2.4 0L4.4 8.8a1.2 1.2 0 0 0 0 2.4m10.8 3.2H1.6V.8A.8.8 0 0 0 0 .8v14.4a.8.8 0 0 0 .8.8h14.4a.8.8 0 1 0 0-1.6"/></svg>`
};
